import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalSection = ({ id, title, children }) => (
  <section id={id} className="mb-9" data-testid={`legal-section-${id}`}>
    <h2 className="text-lg font-bold text-white mb-3">{title}</h2>
    <div className="text-sm text-slate-200 leading-relaxed space-y-3">{children}</div>
  </section>
);

export const LegalLayout = ({ icon: Icon, title, subtitle, testid, children }) => {
  useEffect(() => { document.title = `${title} — B&B KIGALI FM`; window.scrollTo(0, 0); }, [title]);
  return (
    <div className="min-h-screen bg-[#0A0C10]" data-testid={testid}>
      <div className="border-b border-[#273042] bg-gradient-to-b from-[#121620] to-[#0A0C10]">
        <div className="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white mb-6">
            <ArrowLeft className="w-4 h-4" aria-hidden="true" /> Back to home
          </Link>
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-xl bg-[#E11D2A]/15 flex items-center justify-center">
              <Icon className="w-6 h-6 text-[#EF4444]" aria-hidden="true" />
            </span>
            <div>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-white">{title}</h1>
              {subtitle && <p className="text-sm text-slate-300 mt-1">{subtitle}</p>}
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto py-10">{children}</div>
    </div>
  );
};
